export const VERSION = '2.47.1';
